/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Not_LinkedInputs */



/**
* | output |
* | --- |
* | "Not linked into any project yet" |
*
* @param {External_Apis_Space_Not_LinkedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_not_linked = /** @type {((inputs?: External_Apis_Space_Not_LinkedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Not_LinkedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch mit keinem Projekt verknüpft")
	return /** @type {LocalizedString} */ ("Not linked into any project yet")
});